var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"featureflow",rawName:"v-featureflow:isOn",value:('capacity-planner-schedule-page'),expression:"'capacity-planner-schedule-page'",arg:"isOn"}],staticClass:"schedule-page"},[_c('div',{staticClass:"container"},[_c('Schedule',{attrs:{"configuration":_vm.configuration,"workloadTasks":_vm.workloadTasks}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }